import React from "react";
import { Container } from "./styles";
import Title from "../Title";
import BlogPreview from "../BlogPreview";
import moment from "moment";

const BlogSection = (props) => {
  const blogs = props.blogs.slice(0, 2);
  return (
    <Container>
      <div className="title-container">
        <Title
          title={"Blog"}
          subTitle={"See all posts"}
          navigateTo="/all-blogs"
        />
      </div>
      <div className="blogs">
        {blogs.map((blog) => (
          <div className="preview-container" key={blog.id}>
            <BlogPreview
              id={blog.id}
              title={blog.title}
              content={blog.excerpt}
              tags={[blog.category]}
              author={blog.authorName}
              date={moment(blog.created_at).format("MMM DD")}
              image={blog.thumbnail}
            />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default BlogSection;
